const getThumbnailUrl = (size: number) => `https://image.heydealer.com/unsafe/${size}x0`;

export default getThumbnailUrl